<template>
    <div class="w-100">
        <v-card class="p-3">
            <div class="justify-content-between">
                <h5>
                    Prestataires attachés
                    <span v-if="providers.length > 0">
                    ({{providers.length}})
                </span>
                </h5>

                <div class="text-center" v-if="providers.length === 0">
                    <small>
                        Aucun prestataire attaché à l'entreprise
                    </small>
                </div>
                <div v-else>
                    <div class="d-flex m-2" v-for="provider in providers">
                        <div class="mr-3 bg-primary text-white p-1 px-2 rounded" v-if="provider.cat_tag">
                            {{ provider.cat_tag.slice(4).trimStart() }}
                        </div>

                        <div class="mr-3 pt-1">
                            <router-link :to="'/summary/' + encodeUri(provider.id)">{{ provider.name }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "SitEntityProvidersBloc",
    props: [
        "entityId",
    ],
    data() {
        return {
            providers: [],
        }
    },
    methods: {
        getSitEntityProviders() {
            this.$http.get("auth/sit-entity/" + this.entityId + "/providers").then(res => {
                this.providers = res.body.data.sitEntityProviders
            })
        },
        encodeUri(id) {
            return btoa(id)
        },
    },
    created() {
        this.getSitEntityProviders()
    },
}
</script>